import React from "react";
import { Autocomplete, TextField } from "@mui/material";

const options = [
  {
    title: "All",
    value: null,
  },
  {
    title: "Admin",
    value: "admin",
  },
  {
    title: "Employer",
    value: "employer",
  },
];

const SelectCreatedBy = ({ ref, ...props }) => {
  return (
    <Autocomplete
      {...props}
      ref={ref}
      options={options}
      getOptionLabel={(option) => option.title}
      isOptionEqualToValue={(option, value) => {
        if (!option || !value) return false;
        // Handle when value is just a string
        if (typeof value === 'string') {
          return option.value === value;
        }
        // Handle when value is an object
        return option.value === value.value;
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          helperText={props.helpertext}
          label={props.label || "Created By"}
          disabled={props.disabled}
        />
      )}
    />
  );
};

export default SelectCreatedBy;